<template>
  <div
    class="list-group-item list-group-item-action listing-row d-flex flex-row align-items-start gap-2"
    role="button"
    tabindex="0"
    @click="openListingSource"
    @keydown.enter.prevent="openListingSource"
    @keydown.space.prevent="openListingSource"
  >
    <div class="flex-grow-1 listing-row-main">
      <ListingItemView
        :value="listing"
        :hide-address="hideAddress"
      />
    </div>
    <div class="listing-row-actions">
      <IconButton
        button
        small
        icon="arrow-right-circle"
        title="Open in portal"
        @click.stop="openListingInPortal"
      />
    </div>
  </div>
</template>

<script>
import {Listing} from "@/models/Listing";
import ListingItemView from "@/components/ListingItemView.vue";
import IconButton from "@/components/common/IconButton.vue";

export default {
  components: {
    IconButton,
    ListingItemView
  },
  props: {
    listing: Listing,
    hideAddress: Boolean
  },
  emits: ['open-source', 'open-portal'],
  methods: {
    openListingSource() {
      if (!this.listing?.url) {
        this.openListingInPortal();
        return;
      }
      this.$emit('open-source', this.listing);
      window.open(this.listing.url, '_blank', 'noopener,noreferrer');
    },
    openListingInPortal() {
      if (!this.listing?.id) {
        return;
      }
      this.$emit('open-portal', this.listing);
      this.$router.push({
        name: 'listing-detail',
        params: {
          selectedListingId: this.listing.id
        }
      });
    }
  }
};
</script>

<style scoped>
.listing-row {
  cursor: pointer;
}

.listing-row-main {
  min-width: 0;
}

.listing-row-actions {
  align-self: center;
}
</style>
